<div id="componente-swiper">
  <swiper
    [centeredSlides]="true"
    [loop]="true"
    [pagination]="{
      clickable: true
    }"
    [autoplay]="{
      delay: 12000,
      disableOnInteraction: false
    }"
    [lazy]="{ loadPrevNext: true }"
    class="home-swiper-slider"
  >
    <ng-template swiperSlide>
      <div id="zuli-banner" class="banner_image">
        <div class="banner_container">
          <div class="banner_content slide-from-left-fade">
            <div class="image-container">
              <img
                class="zuli-image"
                src="assets/img/zuli-personagem.png"
                alt=""
              />
            </div>
            <div>
              <h1 class="title-zuli">
                <em>
                  Olá, eu sou a
                  <span class="destaqued-orange"> Zuli</span>!</em
                >
              </h1>
              <p class="text-zuli">
                Cheguei para ajudar você a resolver o que for preciso no dia a
                dia do seu negócio.
              </p>
              <ul class="list-zuli">
                <li>• Tire dúvidas</li>
                <li>• Agilize solicitações</li>
                <li>• Receba suporte</li>
              </ul>
              <a
                class="btn btn-big btn-primary slide-from-left-fade"
                href="https://api.whatsapp.com/send/?phone=5511941473336"
                target="_blank"
                >Me adicione no WhatsApp!</a
              >
            </div>
          </div>
        </div>
        <picture>
          <source
            srcset="assets/img/banners/banner-zuli-mobile.jpg"
            media="(max-width: 768px)"
          />

          <source
            srcset="/assets/img/banners/banner-zuli-1920.jpg"
            media="(min-width: 1500px)"
          />

          <img
            class="position-center"
            src="assets/img/banners/banner-zuli-1440.jpg"
            alt=""
          />
        </picture>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div id="clover-banner" class="banner_image">
        <div class="banner_container">
          <div class="banner_content">
            <div class="slide-from-left-fade">
              <div>
                <h1 class="title-clover">
                  <em> azulzinha apresenta o poder do mundo Clover </em>
                </h1>
                <p class="text-clover">
                  Praticidade na gestão e uma experiência de compra que encanta
                  seus clientes.
                </p>
                <ul class="list-clover">
                  <li>
                    <img
                      class="list-clover-icons"
                      src="assets/img/icons/icon-gestao-fullblue.png  "
                    />
                    Gestão simplificada
                  </li>
                  <li>
                    <img
                      class="list-clover-icons"
                      src="assets/img/icons/icon-custos-fullblue.png  "
                    />
                    Menos custos
                  </li>
                  <li>
                    <img
                      class="list-clover-icons"
                      src="assets/img/icons/icon-integracao-fullblue.png  "
                    />
                    Integração ágil
                  </li>
                </ul>
                <a
                  class="btn btn-big btn-primary slide-from-left-fade"
                  href="/clover"
                  >Confira a novidade</a
                >
              </div>
            </div>
          </div>

          <div class="text-right">
            <div class="clover-right">
              <img
                class="logo-caixa-clover img-fluid"
                src="assets/img/logos/logo-caixa-clover.png  "
              />
              <img
                class="maquinas-clover img-fluid"
                src="assets/img/maquinas/clover/maquina-clover-azulzinha.png"
              />
            </div>
          </div>
        </div>
        <picture>
          <source
            srcset="assets/img/banners/banner-clover-pos-carnaval-mb.jpg"
            media="(max-width: 768px)"
          />

          <source
            srcset="/assets/img/banners/banner-clover-pos-carnaval-1920.jpg"
            media="(min-width: 1500px)"
          />

          <source
            srcset="/assets/img/banners/banner-clover-pos-carnaval-1440.jpg"
            media="(max-width: 1200px)"
          />

          <img
            class="position-center"
            src="assets/img/banners/banner-clover-pos-carnaval-1440.jpg"
            alt=""
          />
        </picture>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="banner_image">
        <div class="banner_container">
          <div class="banner_content">
            <div class="slide-from-left-fade">
              <div class="content-pix">
                <h1>
                  <em>
                    É aproximação <br />
                    É agilidade
                  </em>
                </h1>
                <h1 class="title-pix-destaqued">É Pix!</h1>
                <p>
                  Com o Pix por aproximação na azulzinha, agora é só aproximar e
                  pagar via carteira digital ou pelo App do seu banco!
                </p>
                <a class="content-pix-link" href="/pix-azulzinha"
                  >Habilite já</a
                >
              </div>
            </div>
          </div>

          <div class="text-right">
            <div class="content-pix-right">
              <div>
                <span>+ eficiência </span>
                <p>Menos etapas para pagar</p>
              </div>
              <div>
                <span>+ facilidade</span>
                <p>O pagamento é realizado de forma rápida e prática</p>
              </div>
              <div>
                <span>+ segurança</span>
                <p>
                  Proteção extra, pela carteira digital ou App do banco, sem
                  expor saldo
                </p>
              </div>
            </div>
            <img class="image-pix-right" src="assets/img/group-maq-cell.png" />
          </div>
        </div>
        <picture>
          <source
            srcset="assets/img/banners/banner-full-blue-pix-mobile.jpg"
            media="(max-width: 440px)"
          />

          <source
            srcset="/assets/img/banners/banner-full-blue-pix-1920.jpg"
            media="(min-width: 1600px)"
          />

          <source
            srcset="/assets/img/banners/banner-full-blue-pix-1366px.jpg"
            media="(min-width: 441px) and (max-width: 1400px)"
          />

          <img
            class="position-center"
            src="assets/img/banners/banner-full-blue-pix.jpg"
            alt=""
          />
        </picture>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <div class="banner_image">
        <div class="banner_container bg_mobile-end">
          <div class="banner_content">
            <h1 class="slide-from-left-fade">
              <div class="block-text">
                <em>
                  <span class="color-green font-lg"
                    >IPVA, <span class="dsk-block"> licenciamento </span>
                    <span class="dsk-block"> e multas.</span></span
                  >
                </em>
                <div class="sub-title">
                  <em>
                    <span class="color-green">Parcelei</span
                    ><span> com <strong>azulzinha pay!</strong></span></em
                  >
                </div>
              </div>
            </h1>

            <a
              href="https://www.azulzinhapay.com.br/"
              target="_blank"
              class="btn btn-primary slide-from-left-fade mobile-hidden"
              >Visite o portal</a
            >
          </div>

          <div class="text-right">
            <div>
              <p class="mb-0">
                Pague seus débitos veiculares em
                <strong>até 12x no cartão de crédito</strong> de qualquer banco,
                resolvendo
                <span class="d-inline-block"> tudo em um só portal. </span>
              </p>
              <div class="btn-custo-mb">
                <a
                  target="_blank"
                  class="btn btn-primary my-4"
                  href="https://www.azulzinhapay.com.br/"
                  >Visite o portal</a
                >
              </div>
            </div>

            <div class="image-footer">
              <img src="assets/img/logos/azulzinha-pay.png" />
              <p>No seu prazo, do seu jeito.</p>
            </div>
          </div>
        </div>
        <picture>
          <source
            srcset="assets/img/banners/banner-mobile-azulzinha-pay.jpg"
            media="(max-width: 768px)"
          />
          <img src="assets/img/banners/azulzinha-banner-pay.jpg" alt="" />
        </picture>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <app-banner
        [linear]="true"
        title="<div class='mb-3 w-337 '>Com azulzinha você pode muito mais</div>"
        description="Conecte-se a um mundo de soluções que só a CAIXA pode oferecer para
  apoiar sua empresa."
        cta="Conheça"
        url="#dobra"
        img="banner-home-1.jpg"
      />
    </ng-template>

    <ng-template swiperSlide>
      <div class="banner_image bg-mobile">
        <div class="banner_container bg_mobile-end">
          <div class="banner_content">
            <h1 class="slide-from-left-fade">
              <img
                class="logo-caixa-tem"
                src="/assets/img/logos/caixa-tem-v01.svg"
              /><em>
                Venda sem maquininha pelo
                <span class="green-caixa">App CAIXA Tem!</span>
              </em>
            </h1>
            <p class="slide-from-left-fade">
              Receba direto na sua conta digital MEI, ative diversos serviços e
              muito mais!
            </p>

            <a
              href="/azulzinha-caixa-tem"
              class="btn btn-big btn-primary slide-from-left-fade"
              >Confira a novidade</a
            >
          </div>
        </div>

        <picture>
          <source
            srcset="/assets/img/banners/home-banner-mobile.png"
            media="(max-width: 767px)"
          />
          <img src="assets/img/banners/banner-caixa-tem.png" alt="" />
        </picture>
      </div>
    </ng-template>

    <ng-template swiperSlide>
      <app-banner
        title="azulzinha Lotérica pro: o terminal móvel para você"
        description=" Ofereça o serviço de conveniência do TFL com mais agilidade,
      mobilidade e praticidade."
        cta="Confira a novidade"
        url="/lotericas"
        img="banner-home-loterica.png"
      />
    </ng-template>

    <ng-template swiperSlide>
      <app-banner
        title=" Aceite pagamentos com cartão de débito e crédito"
        description=" Ofereça o serviço de conveniência e receba jogos, boletos e contas
      com os cartões Elo, Visa e Mastercard de qualquer banco."
        cta="Saiba mais"
        url="/lotericas#videoId"
        img="lotericasAlternative.jpg"
        [linear]="true"
      />
    </ng-template>

    <ng-template swiperSlide>
      <app-banner
        title="<div>Receba as vendas feitas no crédito em 1 dia útil!</div>"
        description="  Faça a antecipação pelo App ou portal da azulzinha de forma
      prática, em poucos segundos."
        cta="Saiba mais"
        url="/antecipacao-de-vendas"
        img="antecipacaoAlternative.jpg"
        [linear]="true"
      />
    </ng-template>
  </swiper>
</div>
